<template>
  <div class="card card-custom card-transparent">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
          class="wizard wizard-4"
          id="kt_wizard_v4"
          data-wizard-state="step-first"
          data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav">
          <div class="wizard-steps">
            <div
                class="wizard-step"
                data-wizard-type="step"
                data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  1
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Bilgiler
                  </div>
                  <div class="wizard-desc">
                    Kampanyanın detayları
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  2
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    İçerik
                  </div>
                  <div class="wizard-desc">
                    Kampanya açıklaması
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  3
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Tab İçeriği
                  </div>
                  <div class="wizard-desc">
                    Tab menü içerikleri
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  4
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Hedef Kitle
                  </div>
                  <div class="wizard-desc">
                    Hedef kitle seçimi
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body-->
        <div class="card card-custom card-shadowless rounded-top-0">
          <div class="card-body p-0">
            <div class="row justify-content-center py-8 px-8 px-lg-10">
              <div class="col-xl-12 col-xxl-12">
                <!--begin: Wizard Form-->
                <form class="form mt-0 mt-lg-10" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div
                      class="pb-5"
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                  >
                    <div class="row">
                      <div class="col-lg-6">
                        <b-form-group label="Kampanya Adı">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya Adı"
                              v-model="form.name"
                              @input="changeItName($event)"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Kampanya Durumu"
                        >
                          <b-form-select
                              class="form-control form-control-solid"
                              v-model="form.campaign_status"
                              :options="campaign_status"
                          ></b-form-select>
                        </b-form-group>
                        <b-form-group label="Buton Yazısı">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Buton Yazısı"
                              v-model="form.button_text"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Anasayfa Başlığı">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Anasayfa Başlığı"
                              v-model="form.homepage_title"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Detay Sayfası Başlığı">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Detay Sayfası Başlığı"
                              v-model="form.detail_page_title"
                          ></b-form-input>
                        </b-form-group>

                        <div class="row">

                          <div class="col-lg-12">
                            <h3 class="font-size-lg text-dark font-weight-bold mb-6">Kampanya Görseli</h3>
                            <div class="separator separator-dashed my-6"></div>
                            <b-form-group label="940x300px" label-for="file-default" label-cols-sm="2">
                              <b-form-file id="file-default" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                            </b-form-group>

                            <img style="width:100%;border-radius: 8px;" src="http://cdn.napolyon.com/napolyon/profilgorev/PB_kisiselbilgiler_750x330.png" alt="">
                          </div>

                        </div>
                      </div>
                      <div class="col-lg-6">

                        <b-form-group label="Kampanya URL">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya URL"
                              v-model="form.slug"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Bitiş Bantı"
                        >
                          <b-form-select
                              class="form-control form-control-solid"
                              v-model="form.end_tape"
                              :options="end_tapes"
                          ></b-form-select>
                        </b-form-group>
                        <b-form-group label="Buton URL">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Buton URL"
                              v-model="form.button_url"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Anasayfa Açıklaması">
                          <b-form-textarea
                              class="form-control form-control-solid"
                              name="name"
                              placeholder="Anasayfa Açıklaması"
                              v-model="form.homepage_desc"
                          ></b-form-textarea>
                        </b-form-group>

                        <div class="row">

                          <div class="col-lg-6">
                            <b-form-group label="Başlangıç Tarihi" label-for="input-2">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="date"
                                  required
                                  v-model="form.date"
                              ></b-form-input>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group label="Bitiş Tarihi" label-for="input-2">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="date"
                                  required
                                  v-model="form.date"
                              ></b-form-input>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group>
                              <b-form-checkbox
                                  id="checkbox-1"
                                  name="checkbox-1"
                                  v-model="form.winners_campaign"
                                  unchecked-value="not_accepted"
                                  class="mb-5"
                              >
                                Kazananlar Kampanyası Var
                              </b-form-checkbox>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group>
                              <b-form-checkbox
                                  aria-label="checkbox-12"
                                  id="checkbox-12"
                                  name="checkbox-12"
                                  v-model="form.related_survey"
                                  unchecked-value="not_accepted"
                                  class="mb-5"
                              >
                                İlişkili Anket Var
                              </b-form-checkbox>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group label="İlişkili Anket">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.survey"
                                  :options="surveys"
                              ></b-form-select>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group label="Wave">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.wave"
                                  :options="waves"
                              ></b-form-select>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group>
                              <b-form-checkbox
                                  aria-label="checkbox-13"
                                  id="checkbox-13"
                                  name="checkbox-13"
                                  v-model="form.mini_poll"
                                  unchecked-value="not_accepted"
                              >
                                CRM Mini Anket
                              </b-form-checkbox>
                            </b-form-group>
                          </div>

                          <div class="col-lg-6">
                            <b-form-group>
                              <b-form-checkbox
                                  aria-label="checkbox-14"
                                  id="checkbox-14"
                                  name="checkbox-14"
                                  v-model="form.mobile_view"
                                  unchecked-value="not_accepted"
                              >
                                Mobilde Göster
                              </b-form-checkbox>
                            </b-form-group>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <template>
                      <RichTextArea></RichTextArea>
                    </template>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <b-tabs content-class="mt-3">
                      <b-tab title="TAB 1" active>
                        <b-form-group label="Başlık">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya Adı"
                              v-model="form.tab1_title"
                          ></b-form-input>
                        </b-form-group>
                        <RichTextArea></RichTextArea>

                      </b-tab>
                      <b-tab title="TAB 2">
                        <b-form-group label="Başlık">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya Adı"
                              v-model="form.tab2_title"
                          ></b-form-input>
                        </b-form-group>
                        <RichTextArea></RichTextArea>
                      </b-tab>
                      <b-tab title="TAB 3">
                        <b-form-group label="Başlık">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya Adı"
                              v-model="form.tab3_title"
                          ></b-form-input>
                        </b-form-group>
                        <RichTextArea></RichTextArea>
                      </b-tab>
                      <b-tab title="TAB 4">
                        <b-form-group label="Başlık">
                          <b-form-input
                              class="form-control form-control-solid"
                              type="text"
                              name="name"
                              placeholder="Kampanya Adı"
                              v-model="form.tab4_title"
                          ></b-form-input>
                        </b-form-group>
                        <RichTextArea></RichTextArea>
                      </b-tab>
                    </b-tabs>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Step 4-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <b-form-textarea
                        id="textarea-rows"
                        placeholder="Hedef Kitle"
                        rows="8"
                        v-model="form.target_group"
                    ></b-form-textarea>
                  </div>
                  <!--end: Wizard Step 4-->

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                          class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-prev"
                      >
                        ÖNCEKİ
                      </button>
                    </div>
                    <div>
                      <button
                          v-on:click="submit"
                          class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-submit"
                      >
                        KAYDET
                      </button>
                      <button
                          class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-next"
                      >
                        SONRAKİ
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Bpdy-->
      </div>

      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-4.scss";
</style>
<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import DataTable from "@/assets/components/dataTable/DataTable";
import RichTextArea from "@/view/pages/vue-bootstrap/RichTextArea";

export default {
  name: "EditCampaign",
  components: {RichTextArea},
  data(){
    return {
      form : {
        name: '2021 Beklentiler',
        slug: '2021-beklentiler',
        url: '2021-beklentiler',
        campaign_status : 'Test Modu',
        end_tape : 'Sarı',
        survey : 'Limonist (P12929)',
        wave : 1,
        button_text : 'Hemen Tıkla',
        button_url : '#',
        homepage_desc : 'Anasayfa Test Açıklaması',
        homepage_title : 'Anasayfa Test Başlığı',
        detail_page_title : 'Detay Sayfası Test Başlığı',
        date : '2020-12-11',
        winners_campaign: true,
        related_survey : true,
        mini_poll : true,
        mobile_view : true,
        tab1_title : "Tab 1 Test Başlığı",
        tab2_title : "Tab 2 Test Başlığı",
        tab3_title : "Tab 3 Test Başlığı",
        tab4_title : "Tab 4 Test Başlığı",
        target_group : 'SQL * ...'
      },
      campaign_status: [{ text: this.$t('general.select'), value: null } , 'Test Modu','Aktif', 'Pasif'],
      end_tapes: [{ text: this.$t('general.select'), value: null } , 'Mavi','Sarı', 'Kırmızı'],
      surveys : [{ text: this.$t('general.select'), value: null } , 'Limonist (P12929)','Deneme (P12928)', 'Test (P12927)'],
      waves: [{ text: this.$t('general.select'), value: null } , '1','2', '3','4','5','6'],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kampanyalar", route: "Campaigns" },
      { title: "2021 Beklentiler" }
    ]);

    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v4", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    changeItName(){
      this.form.slug = _.kebabCase(this.form.name);
    },

    submit: function (e) {
      e.preventDefault();
      Swal.fire({
        title: "",
        text: "Kampanya başarıyla güncellendi!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Tamam",
      });
    }
  }
};
</script>

